"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Header;
var _bem = require("../../utils/bem");
var _jsxRuntime = require("react/jsx-runtime");
function Header(props) {
  var _useClass = (0, _bem.useClass)('modal', props),
    getElementClass = _useClass.getElementClass;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
    className: getElementClass('header'),
    children: props.children
  });
}